<template>
  <div class="page">
    <h2>有看投隐私政策摘要</h2>
    <h2>更新日期：2026年 08月 20日</h2>
    <h2>生效日期：2026年 08月 20日</h2>
    <p>
      我们非常重视您的隐私保护，在您使用有看投服务时，现将通过《有看投隐私政策摘要》（“隐私政策摘要”），简单告知您我们如何收集、使用、共享您的个人信息，以及您如何管理您的个人信息。详细的隐私政策，请查看完整版的<a
        class="c5"
        @click="openPrivacyPage('privacy-index')"
        >《有看投隐私政策》</a
      >。
    </p>
    <h2>一、我们收集的信息</h2>
    <p class="strong">1、注册、登录、使用</p>
    <p>手机号码、验证码、密码、用户ID、第三方账号信息。</p>
    <p class="strong">2、监管与风险防范</p>
    <p>
      为了保障互联网应用的业务安全风控，应对欺诈、违法等安全风险，满足监管要求，提升服务安全性，防止您的个人信息被违法获取，您同意我们记录您使用产品的方式及相关操作信息，例如硬件序列号、操作系统版本、设备MAC地址、IP地址、无线网络接入信息、唯一设备识别码（如IMEI/OAID/Android
      ID/IDFA/Open
      UDID/GUID/SIM卡IMSI信息等个人常用设备基本情况的信息）、软件版本号、网络接入方式、类型、状态、操作、使用产品使用习惯以及其他与有看投服务相关的日志信息以及其他能识别客户终端的特征代码。特别地，为进行疑问解答、投诉处理及合规回访，我们需要收集手机号码；为进行风险提示，我们需要收集合规录音；为提供图片上传和导入功能，我们需要收集您上传的图片信息；为提供营业信息，我们需要收集您的位置信息。
    </p>
    <p>
      如您希望更详细的了解我们收集个人信息的类型与目的，您可以详细阅读<a
        class="c5"
        @click="openPrivacyPage('privacy-personal')"
        >《个人信息收集清单》</a
      >。
    </p>
    <h2>二、我们需要开启的设备权限</h2>
    <p class="strong">1、通知</p>
    <p>
      允许通知，可以为您提供重点事项的通知（如评论、预警、活动、行业重要公告、系统升级等）、服务资讯的推送等。
    </p>
    <p class="strong">2、WIFI及移动网络数据的权限</p>
    <p>允许使用WLAN与移动网络。用于您使用我们的产品及服务。</p>
    <p class="strong">3、电话、音频及麦克风权限</p>
    <p>
      允许拨打客服电话或接听工作人员的回电，以及使用IM发送语音消息，提升客户服务效率。
    </p>
    <p class="strong">4、录音权限</p>
    <p>
      允许录音或通话录音权限。由于您在使用产品/服务过程中，需要进行风险提示、合规录音。
    </p>
    <p class="strong">5、摄像头、相机权限</p>
    <p>
      允许获取您的摄像头、相机权限。方便您拍照提供产品建议、上传材料以及视频功能。
    </p>
    <p class="strong">6、相册权限及手机存储权限</p>
    <p>
      允许获取您的相册权限及手机存储权限。方便您缓存资讯信息、使用图片的缓存、上传、保存、识别、编辑与分享功能。
    </p>
    <p class="strong">7、剪贴板</p>
    <p>允许使用剪贴板。方便您复制、粘贴文本信息。</p>
    <p class="strong">8、画中画</p>
    <p>
      允许使用画中画功能时，我们可能调用操作系统提供的画中画能力，将正在播放的视频以小窗口形式展示，使您在浏览其他页面或进行其他操作时仍可继续观看。
    </p>
    <h2>三、我们如何委托处理或共享您的信息</h2>
    <p>
      为了向您提供更完善、优质的产品和服务之目的，我们可能会委托合作伙伴处理您的某些个人信息，以为您提供更好的服务和体验。请您注意，我们仅会出于合法、正当、必要、特定、明确的目的提供您的个人信息，并且只会提供履行与您的合同所必要的个人信息。我们将会对信息数据的输出形式、流转、使用进行安全评估与处理，以保护数据安全。
    </p>
    <p>
      为了向您提供更完善、优质的产品和服务，为履行与您的合同之必需，我们的商业合作伙伴为您提供部分服务，此种情形下，我们可能会与合作伙伴共享您的某些个人信息，以为您提供更好的服务和体验。请您注意，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们将会对信息数据的输出形式、流转、使用进行安全评估与监督，以保护数据安全。
    </p>
    <p>
      如您希望了解我们与第三方共享个人信息的类型和目的，以及有看投平台嵌入的第三方SDK情况，您可以详细阅读<a
        class="c5"
        @click="openPrivacyPage('privacy-sdklist')"
        >《第三方信息共享清单》</a
      >。
    </p>
    <h2>四、我们如何保护个人信息</h2>
    <p>
      为保障您的信息安全，我们致力于使用各种安全技术及配套的管理体系来尽量降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。同时我们设立了相关内控制度，对可能接触到您的信息的工作人员采取最小够用授权原则；对工作人员处理您的信息的行为进行系统监控，不断对工作人员培训相关法律法规及隐私安全准则和安全意识强化宣导。另外，目前我们的重要信息系统已经通过网络安全等级保护的二级及以上测评。
    </p>
    <p>
      在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议等。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
    </p>
    <p>
      我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息透露给他人。如您发现您的用户名、密码及其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。
    </p>
    <p>
      如果未满十四周岁的未成年人（“儿童”）使用我们的产品或服务，我们将根据所有适用法律法规的要求、在征得儿童监护人同意的情形下处理儿童的个人信息。
    </p>
    <h2>五、您如何管理您的个人信息</h2>
    <p class="strong">1、访问、更正及更新您的个人信息</p>
    <p>
      您可以在使用我们服务的过程中，通过我们的软件访问、更正及更新您提供的注册信息和其他个人信息，具体路径如下：有看投平台-右上角点击账号-用户中心-个人信息。对于软件无法更正或更新的个人信息，您也可联系您的客服专员或拨打我们的客服热线咨询更正及更新事宜。您访问、更正及更新个人信息的范围和方式将取决于您使用的具体服务。
    </p>
    <p class="strong">2、撤回同意</p>
    <p>
      您可以通过我们提供的手机软件撤回授权，具体路径为：有看投手机软件-首页左上角个人中心-隐私管理-隐私政策-底部撤回同意。点击即可撤回同意。
    </p>
    <p class="strong">3、注销账户</p>
    <p>
      我们为您提供了注销账户的服务，我们的手机软件中的注销路径为：有看投手机软件（IOS）-首页左上角个人中心-账号注销，点击操作注销账户。
    </p>
    <h2>六、如何联系我们</h2>
    <p class="strong">(一)沟通渠道</p>
    <p>
      我们设置了个人信息保护工作机制和个人信息保护负责人，如您对本政策或您个人信息的相关事宜有任何问题、意见或建议，或您在使用有看投服务时，就您的个人信息的收集、使用、提供、访问、更正、删除、撤销与注销事宜有任何意见或建议，或您在使用有看投服务时遇到任何问题，您都可以通过以下联系方式与我们的个人信息保护负责人进行联络：
    </p>
    <p>电话：4006021010</p>
    <p>联系邮箱：yicai@emoney.cn</p>
    <p>
      我们将在必要的身份验证通过后进行处理，在15日内对您的咨询、投诉或举报做出答复。
    </p>
    <p class="strong">(二)特别提示</p>
    <p>
      1、我们提醒您，如您反馈的问题涉及您的个人信息，尤其是您的个人敏感信息，请您不要直接在邮件或电话中进行透露，我们将会在确保您个人信息安全的情况下与您进一步沟通。
    </p>
    <p>
      2、部分情况下，为保障您个人信息安全，我们可能需要您提供书面请求，或以其他方式证明您的身份。我们将在收到您的反馈并验证您的身份后的合理期限内答复您的相关请求。如您对我们的答复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以相关监管部门进行投诉或举报。
    </p>
  </div>
</template>
<style>
html,
body {
  background-color: #ffffff;
  word-break: break-all;
}

table {
  margin: 20px 0;
  min-height: 25px;
  line-height: 45px;
  text-align: center;
  border-collapse: collapse;
}

table,
table tr th,
table tr td {
  border: 1px solid #000000;
}

td {
  padding: 0 10px;
}

* {
  padding: 0;
  margin: 0;
}

.black body,
body.black {
  background-color: #111112;
  color: #bfbfbf;
}

a {
  color: #4690ef;
}

.page {
  padding: 15px 10px 30px;
  max-width: 640px;
  margin: 0 auto;
  font-size: 30px;
}

h2 {
  font-weight: bold;
  font-size: 32px;
  margin: 15px 0;
}

.strong {
  font-weight: bold;
}

p {
  text-indent: 2em;
}

.btn-cancel {
  margin: 45px 22px 0;
  border: 1px solid #dddddd;
  border-radius: 5px;
  line-height: 100px;
  text-align: center;
  font-size: 17px;
  color: #8c8c8c;
  display: none;
}

.black .btn-cancel {
  border-color: #1e262a;
  color: #828282;
}
</style>
<script>
import { yktappUrl } from '@/assets/js/Urls'
import { Log } from '@em/ym'

export default {
  mounted() {
    Log.pageView({
      pageId: 'Html:PrivacyPolicySummary'
    })
  },
  methods: {
    openPrivacyPage(route) {
      location.href = yktappUrl(route)
    }
  }
}
</script>
